import { AppConfig } from './types';

/**
 * Environment-specific configuration
 * Uses Vite's environment variables (import.meta.env)
 */
const config: AppConfig = {
  backendUrl:
    import.meta.env.VITE_BACKEND_URL ||
    'http://localhost:8080/api',

  frontendUrl: {
    host:
      import.meta.env.VITE_FRONTEND_HOST ||
      'localhost:3000',
    protocol: (import.meta.env.VITE_FRONTEND_PROTOCOL ||
      'http') as 'http' | 'https',
  },

  // API Documentation URL (optional)
  apiDocumentationUrl: import.meta.env
    .VITE_API_DOCUMENTATION_URL,

  // Cloud Function URL
  cloudFunction:
    import.meta.env.VITE_CLOUD_FUNCTION_URL ||
    'https://functions.fitra.cl',

  // Tenant configuration
  tenantMode: (import.meta.env.VITE_TENANT_MODE ||
    'multi') as AppConfig['tenantMode'],

  // Payment configuration
  isPlanEnabled:
    import.meta.env.VITE_IS_PLAN_ENABLED === 'true',
  stripePublishableKey: import.meta.env
    .VITE_STRIPE_PUBLISHABLE_KEY,
};

export default config;
